import React from 'react';
import {useTranslation} from 'react-i18next';

/**
 * El aviso de que el agrupador no miró todas las cuentas.
 *
 * El backend compara todas las cuentas contra todas, así que corta a partir de cierto padrón
 * (`CLIENT_GROUPING_MAX_ACCOUNTS`) y devuelve el resto en `unassigned` con motivo
 * `TOO_MANY_ACCOUNTS`. Sin este aviso, la agencia que lo supera ve buena parte de su padrón en el
 * cajón de «asignalo vos» y no tiene forma de saber por qué — parece que Dashbo no entendió nada.
 *
 * El tope es del PEDIDO, no de esas cuentas en particular, así que se dice arriba y una sola vez, no
 * como motivo repetido fila por fila.
 *
 * **El número sale del payload.** Escribirlo acá a mano garantiza que el día que el backend lo mueva
 * —ya pasó de 500 a 8000— el aviso mienta, y un aviso que da una cifra equivocada es peor que no
 * darla: manda a buscar cuentas que no faltan.
 */
export function CapNotice({stats}) {
    const {t} = useTranslation();
    // `over_the_limit` FALTA en la respuesta cuando no hubo nada que agrupar: el `|| 0` no es
    // defensivo por las dudas, es el caso real de una agencia sin cuentas agrupables.
    const overTheLimit = (stats && stats.over_the_limit) || 0;
    if (!overTheLimit) return null;

    const limit = stats && stats.limit;
    return (
        <p className="ob-cap-notice" role="status">
            {limit
                ? t('onboarding.clients.cap_notice', {count: overTheLimit, limit})
                : t('onboarding.clients.cap_notice_no_limit', {count: overTheLimit})}
        </p>
    );
}

export default CapNotice;
